$(function () {
  var url = document.URL;

  $('#back-button').on('click', function () {
    if (document.referrer !== '') {
      window.history.back();
    } else {
      window.location.href = url.substring(0, url.lastIndexOf('/'));
    }
  });
});


// WEBPACK FOOTER //
// ./app/webpacker/src/js/back_button.js